
import { lazy, Suspense } from "react";
import { usePageTitle } from '@/hooks/usePageTitle';
import { TableSkeleton } from '@/components/ui/skeletons';
import { PageHeader } from '@/components/ui/page-header';
import { PageHeaderActionsProvider } from '@/components/ui/page-header-actions';

const DealTypesTable = lazy(
  () => import('@/components/deal-types/deal-types-table').then(m => ({ default: m.DealTypesTable }))
);

function DealTypesPage() {
  usePageTitle('Deal Types');
  const { id } = Route.useSearch();

  return (
    <PageHeaderActionsProvider>
      <div className="space-y-6">
        <PageHeader
          title="Deal Types"
          description="Categorize deals and add custom fields tailored to each workflow."
          askAi
          hideTitleOnMobile={false}
        />
        <DealTypesTable initialId={id} />
      </div>
    </PageHeaderActionsProvider>
  );
}

import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dashboard/settings/deal-types')({
  validateSearch: (search: Record<string, unknown>) => ({
    id: typeof search.id === 'string' && search.id.length > 0 ? search.id : undefined,
  }),
  component: DealTypesPage,
  pendingComponent: () => <div className="flex flex-col gap-4 flex-1 min-h-0"><TableSkeleton rows={8} /></div>,
  pendingMs: 0,
  pendingMinMs: 150,
});
